import { update } from 'Emitter';
import { getUID } from 'Misc/id';
import beaconPath from './OVVBeacon.swf';
import { Flash } from 'Misc/environment';
import { VIEWABILITY } from 'StateEvents';
import { getThrottler } from 'Misc/timing';

export default class ViewabilityManager {
  constructor() {
    this.measurementEnabled = 'unknown';
    this.startPending = false;
    this.throttler    = getThrottler();
  }

  onUpdate(nextState, prevState, changes) {
    this.state = nextState;

    if(nextState.configuration_parsed && nextState.display.container && this.measurementEnabled === 'unknown') {
      this.measurementEnabled = nextState.configuration.Measurement.internal_viewability;

      if(this.measurementEnabled) {
        this.container = nextState.display.container;
        import('OpenVV').then(this.initViewability.bind(this));
      }
    }

    if(this.canStart) {
      this.startPending = true;

      this
        .startViewability()
        .then(asset => {
          this.asset = asset;
          this.startPending = false;
        })
        .catch(err => {
          update(VIEWABILITY.UNSUPPORTED, 'initViewability', err);
        });
    }

    if(nextState.viewability.started && this.asset && this.throttler.canRun) {
      update(VIEWABILITY.SNAPSHOT, 'onUpdate', this.asset.checkViewability());
    }
  }

  initViewability(OpenVV) {
    if(!this.measurementSupported(OpenVV)) {
      update(VIEWABILITY.UNSUPPORTED, 'initViewability', true);
    } else {
      update(VIEWABILITY.INITIALIZED, 'initViewability', true);
      this.OpenVV = OpenVV;
    }
  }

  get canStart() {
    return this.measurementEnabled === true && this.state.media.current_time > 0 && this.state.viewability.initialized && !this.state.viewability.started && !this.startPending && !this.state.viewability.unmeasureable;
  }

  measurementSupported(OpenVV) {
    const beaconsSupported = new OpenVV.OVVBeaconSupportCheck().supportsBeacons();

    return (
      this.container                                               &&
      OpenVV.$ovv.intersectionObserverSupported                    ||
      OpenVV.$ovv.geometrySupported                                ||
      OpenVV.$ovv.browser.ID === OpenVV.$ovv.browserIDEnum.Firefox
    );
  }

  startViewability() {
    this.startPending = true;
    update(VIEWABILITY.STARTED, 'startViewability', true);
    return this.createAsset(this.container);
  }

  createAsset(measuredElement) {
    return new Promise( (resolve, reject) => {
      let asset;

      const uid    = `ovv${getUID()}`,
            deps   = { geometryViewabilityCalculator: new this.OpenVV.OVVGeometryViewabilityCalculator() },
            config = {
              measuredElement,
              beaconPath,
              readyCallback: () => {
                resolve(asset);
              }
          };

      asset = new this.OpenVV.OVVAsset(uid, deps, config);
      this.OpenVV.$ovv.addAsset(asset);
    });
  }
}


// WEBPACK FOOTER //
// ./src/Viewability/ViewabilityManager.js